
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardInnerLayout extends Vue {
    @Prop({ type: String, default: '' }) headerText!: string;

    @Prop({ type: String, default: '' }) nameText!: string;

    headerOverflow = false;

    nameOverflow = false;

    mounted(): void {
        this.updateOverflowState();
        window.addEventListener('resize', this.updateOverflowState);
    }

    updated(): void {
        this.updateOverflowState();
    }

    beforeDestroy(): void {
        window.removeEventListener('resize', this.updateOverflowState);
    }

    updateOverflowState(): void {
        this.headerOverflow = this.isOverflowing('headerTextElement');
        this.nameOverflow = this.isOverflowing('nameTextElement');
    }

    isOverflowing(refName: string): boolean {
        const element = this.$refs[refName] as Vue | HTMLElement | undefined;
        const htmlElement =
            element instanceof HTMLElement ? element : element?.$el;

        return (
            !!htmlElement && htmlElement.scrollWidth > htmlElement.clientWidth
        );
    }
}
